export const TermsAndConditionsCheckbox = {
  fontSize: "20px",
  color: "#000000",
  lineHeight: "24px",
  fontWeigh: "400"
};
